import React from 'react';

const Add = () => {
    return (
        <div>
            Add photo
        </div>
    );
};

export default Add;